module.exports = __webpack_public_path__ + "0a495ede62a608f55969122d7f2289c2.pdf";